import LynksTable from "./LynksTable";

export default LynksTable;
